import { queryOptions } from '@tanstack/react-query';

import type { components } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type AwayScheduleBlock = components['schemas']['AwayScheduleBlock'];

/** Prefix of every away-schedule key, for invalidating across accounts. */
export const AWAY_SCHEDULE_QUERY_KEY = ['awayScheduleV2'] as const;

/**
 * The signed-in expert's away blocks, ordered by start date. Dates are
 * calendar days as `YYYY-MM-DD` with no timezone, and both ends are inclusive.
 * Keyed by user id so acting as another account never shows the previous
 * account's schedule.
 */
export async function getAwayScheduleV2(): Promise<AwayScheduleBlock[]> {
  const { data } = await fetchClient.GET('/v2/users/me/away-schedule');

  return data?.data ?? [];
}

export const getAwayScheduleV2QueryOptions = (userId?: string) =>
  queryOptions({
    queryKey: [...AWAY_SCHEDULE_QUERY_KEY, userId ?? 'self'] as const,
    queryFn: getAwayScheduleV2,
  });
